module.exports = __webpack_public_path__ + "static/media/摄像头模块.12245a81.png";